import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;

  button:last-of-type {
    width: 9.75rem;
    height: 3rem;
    margin-left: auto;
    margin-right: 2rem;
    background-color: var(--white);
  }
`;

export const ScheduleModalForm = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  row-gap: 1rem;
  column-gap: 2rem;
`;

export const DayContainer = styled.div`
  width: 100%;

  span {
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: var(--grey-100);
  }
`;

export const DayInputContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
  column-gap: 1rem;
  margin-bottom: 0;

  div {
    width: 100%;

    input {
      width: 100%;
    }
  }
`;
